export const softs = [
    {
        "name": "OpenLatex",
        "year": "2026",
        "type": "platform",
        "tags": ["LaTeX", "Cloud", "Kubernetes", "Real-time", "Web"],
        "description": "Plateforme LaTeX collaborative cloud-native (Quarkus, React 19, Kubernetes) : edition temps reel multi-utilisateurs, compilation isolee par projet, previsualisation PDF SyncTeX et synchronisation Git.",
        "url": "https://openlatex.lange.xyz/",
        "download": "https://gitlab.com/blange/openlatex",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": "images/softs/openlatex.png"
    },
    {
        "name": "Airy Collimator",
        "year": "2026",
        "type": "soft",
        "tags": ["Astronomy", "Python", "Image processing"],
        "description": "Outil interactif de collimation en temps reel pour telescopes Celestron, base sur l'analyse de la tache d'Airy (camera ZWO ASI, webcam ou image fixe).",
        "url": "",
        "download": "https://gitlab.com/blange/astro",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": "images/softs/airy-collimator.png"
    },
    {
        "name": "Root Viewer",
        "year": "2026",
        "type": "soft",
        "tags": ["Image processing", "Python", "Paleography", "AI"],
        "description": "Application web (Flask) d'analyse d'images : editeur de pipeline en graphe (DAG) chainant des modules de traitement d'image sur des piles TIFF. Deux usages : analyse d'images racinaires avec export du graphe au format RSML, et analyse d'ecritures historiques (annotation de lignes et transcription assistee).",
        "url": "",
        "download": "",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": ""
    },
    {
        "name": "kg — Code Knowledge Graph",
        "year": "2026",
        "type": "soft",
        "tags": ["Knowledge graph", "AI", "Python", "Tooling"],
        "description": "Plugin Claude Code ajoutant une couche de standardisation et d'analyse au-dessus de graphify : resumes par fonction, mesure de divergence inter-depots et agents de refactoring.",
        "url": "",
        "download": "https://gitlab.com/blange/knowledge-graph",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": ""
    },
    {
        "name": "Plateforme Polytech",
        "year": "2026",
        "type": "platform",
        "tags": ["Teaching", "Web"],
        "description": "Plateforme pedagogique pour les enseignements de Polytech Montpellier (comptes enseignants et etudiants).",
        "url": "https://polytech.lange.xyz/",
        "download": "",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": "images/softs/polytech.png"
    },
    {
        "name": "pdf-pres",
        "year": "2026",
        "type": "soft",
        "tags": ["macOS", "Swift", "Presentation"],
        "description": "Native macOS PDF presenter (SwiftUI + AppKit, macOS 13+) for live talks.",
        "url": "https://github.com/blange48/pdf-pres",
        "download": "https://github.com/blange48/pdf-pres/tags",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": "images/softs/pdf-pres.png"
    },
    {
        "name": "pfalcON",
        "year": "2013",
        "type": "soft",
        "tags": ["HPC", "Parallelism", "Astrophysics"],
        "description": "Parallel implementation of the Dehnen FALCON algorithm",
        "url": "",
        "download": "",
        "paper": "https://www.researchgate.net/publication/265416053_Parallel_Dual_Tree_Traversal_on_Multi-core_and_Many-core_Architectures_for_Astrophysical_N-body_Simulations",
        "authors": ["benoit", "pierre"],
        "screenshot": ""
    },
    {
        "name": "Promise",
        "year": "2023",
        "type": "platform",
        "tags": ["One Health", "AMR", "Data analytics"],
        "description": "One Health Platform for Antimicrobial Resistance Data Analytics",
        "url": "https://data.amr-promise.fr",
        "download": "",
        "abstract": "",
        "paper": "",
        "authors": ["benoit", "florent", "reza"],
        "screenshot": "images/softs/promise.png"
    },
    {
        "name": "Burst viewer",
        "year": "2025",
        "type": "soft",
        "tags": ["Climate", "Visualization", "Time series"],
        "description": "A climate burst viewer to analyze climate data (temperature, humidity, etc.)",
        "url": "",
        "download": "",
        "abstract": "",
        "paper": "",
        "authors": ["guillaume", "benoit", "dennis", "audrey", "florent", "reza"],
        "screenshot": "images/softs/burst.png"
    },
    {
        "name": "2OD",
        "year": "2024",
        "type": "soft",
        "tags": ["Anomaly detection", "Time series", "Distributed"],
        "description": "An online distributed outlier detection method for time-series data",
        "url": "",
        "download": "https://github.com/RebeccaSalles/2OD",
        "paper": "https://www.sciencedirect.com/science/article/abs/pii/S0306437925000092",
        "authors": ["rebecca", "benoit", "florent", "reza", "Eduardo", "esther"],
        "screenshot": ""
    },
    {
        "name": "data-cafe",
        "year": "2023",
        "type": "platform",
        "tags": ["Data factory", "Cloud", "Visualization"],
        "description": "A data-factory platform to extract information, knowledge, and wisdom from data (a DATA TERRAE project)",
        "url": "",
        "download": "",
        "abstract": "",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": "images/softs/data-cafe.png"
    }, {
        "name": "data-cafe games",
        "year": "2023",
        "type": "soft",
        "tags": ["Serious game", "Web"],
        "description": "A collection of mini-games to discover DATA TERRAE projects",
        "url": "",
        "download": "",
        "abstract": "",
        "paper": "",
        "authors": ["benoit"],
        "screenshot": ""
    }, {
        "name": "ENRICO",
        "year": "2024",
        "type": "soft",
        "tags": ["Energy", "Green IT", "Measurement"],
        "description": "An energy-measurement platform for software development and research.",
        "url": "",
        "download": "",
        "paper": "https://hal.science/hal-04925890",
        "authors": ["benoit"],
        "screenshot": ""
    },

]

export const tagCategories = [
    {
        label: "Domaine",
        color: "#1a237e",
        tags: ["AMR", "Astronomy", "Astrophysics", "Climate", "Energy", "One Health", "Paleography", "Teaching"]
    },
    {
        label: "Méthode",
        color: "#6a1b9a",
        tags: ["AI", "Anomaly detection", "Data analytics", "Image processing", "Knowledge graph", "Measurement", "Time series", "Visualization"]
    },
    {
        label: "Infrastructure",
        color: "#00796b",
        tags: ["Cloud", "Distributed", "Green IT", "HPC", "Kubernetes", "Parallelism", "Real-time"]
    },
    {
        label: "Technologie & format",
        color: "#e65100",
        tags: ["Data factory", "LaTeX", "Presentation", "Python", "Serious game", "Swift", "Tooling", "Web", "macOS"]
    }
];
